if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if($('body').hasClass('book-cover')) return;
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);

      if($(".book-covering .cover-box").prop('checked') == true){
        formData.append('properties[Book Covering]', 'Added'); 
        formData.append('properties[cover_for]', this.form.querySelector('[name=id]').value);
      }
      
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {

        if($(".book-covering .cover-box").prop('checked') == true){ console.log("cover");
          var qty = $(".product-form__input.product-form__quantity quantity-input [name='quantity']").val();//response.quantity;
           // console.log("qty=", qty);
          if(qty == undefined)qty = $(click_event).parents('li').find('.quantity__input').val();
          // console.log("qty=", qty);
          var lg1 = $('.book-covering .cover-box').val();
          formData.append('id',lg1);
          formData.append('quantity', qty);
        
          config.body = formData;
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((result) => {
              location.href = "/cart";
            })
            .catch((error) => {
              console.error('Error:', error);
            });
          }
          
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
